import React from "react";

class AbstractStep {

    list = {};

    getStepName = (stepIndex) => this.list[stepIndex].name === undefined ? 'Nom étape inconnu' : this.list[stepIndex].name;

    getStepContent = (stepIndex) => this.list[stepIndex].component === undefined ? <React.Fragment>Contenu étape inconnu</React.Fragment> : this.list[stepIndex].component;
    getExtraProps = (stepIndex) => {
        const { name, page, ...extraProps } = this.list[stepIndex];
        return extraProps;
    }

    getSteps = () => Object.keys(this.list).map(key => this.list[key].name)
}

export default AbstractStep